/* Nida Safety — hareket katmanı (v2, hız düzeltmesi 2026-09-26)
   v1 ile AYNI görünüm (aynı öğeler, aynı kayma/süre/eğri, aynı sıralı giriş), ama:
   - ScrollTrigger yerine tek IntersectionObserver (açılışta tek tek konum ölçümü / zorunlu yeniden yerleşim yok)
   - 600 ms'de bir tüm kartları ölçen "nöbet" döngüsü YOK (masaüstünde 4 uzun görev üretiyordu)
   - İlk ekrandakilere dokunulmaz: gözlemcinin ilk bildiriminde zaten görünür olanlar gizlenmeden bırakılır
   Güvenlik: GSAP yoksa / hareket azaltılmışsa / sekme arka plandaysa hiçbir şey gizlenmez. */
(() => {
 // Mobilde (<750px) ilk kullanıcı etkileşimine kadar kurulmaz (açılışta ana iş parçacığı boş kalsın — PSI mobil TBT).
 // O ana kadar hiçbir şey gizlenmez; ilk dokunuş/kaydırmada ekran dışındakiler gizlenip göründükçe gelir.
 const kur = () => {
  const g = window.gsap;
  if (!g || !('IntersectionObserver' in window) || document.hidden) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('nx-gsap');
  // (2026-10-03 INP) Ekran disindakileri gizlemek icin oge basina gsap.set YERINE sinif: gsap.set her ogede
  // hesaplanmis stil okuyup zorunlu stil hesabi yaptiriyordu (mobil 4x'te ilk dokunusta ~1,4 sn). Gorunum ayni.
  if (!document.getElementById('nx-gizli-css')) {
    const st = document.createElement('style'); st.id = 'nx-gizli-css';
    st.textContent = '.nx-gsap .nx-gizli{opacity:0;visibility:hidden;transform:translate3d(0,var(--nx-y,22px),0)}';
    document.head.appendChild(st);
  }
  const gizle = (el, y) => { el.style.setProperty('--nx-y', y + 'px'); el.classList.add('nx-gizli'); };
  const goster = (el, y, ayar) => {
    g.fromTo(el, { autoAlpha: 0, y }, Object.assign({ autoAlpha: 1, y: 0, clearProps: temizle }, ayar));
    el.classList.remove('nx-gizli'); el.style.removeProperty('--nx-y');
  };

  const KART = '.resource-list__slide, .resource-list__item, .product-grid__item, .nsc-kart';
  const OGE = ['.nida-tb__item', '.nkv__col', '.nida-brand-panel', '.nb2b__alan',
    '.featured-blog-posts-card__content', '.nida-trust-item', '.trust-bar__item'].join(',');
  const BASLIK = '.text-block h3, .nsc__baslik';
  const temizle = 'transform,opacity,visibility';

  // tür → giriş ayarı (v1 değerleri)
  const tur = (el) => el.matches(KART) ? { y: 26, d: 0.6, s: 0.06 } : el.matches(BASLIK) ? { y: 18, d: 0.6, s: 0, baslik: true } : { y: 22, d: 0.65, s: 0.07 };
  const bekleyen = new Set();
  let kuyruk = [], zaman = null;
  const oynat = () => {
    zaman = null;
    const b = kuyruk; kuyruk = [];
    // aynı anda görünenler sıralı gelir (v1'deki batch + stagger)
    b.forEach((el, i) => {
      const t = tur(el);
      if (t.baslik) el.classList.add('nx-cizgi--acik');
      goster(el, t.y, { duration: t.d, ease: 'power3.out', delay: i * (t.s || 0.06) });
    });
  };
  const io = new IntersectionObserver((girdiler) => {
    for (const e of girdiler) {
      const el = e.target;
      if (!bekleyen.has(el)) {           // ilk bildirim: şu an görünüyorsa dokunma, değilse gizle ve bekle
        if (e.isIntersecting) { io.unobserve(el); continue; }
        const t = tur(el);
        if (t.baslik) el.classList.add('nx-cizgi');
        gizle(el, t.y);
        bekleyen.add(el);
        continue;
      }
      if (!e.isIntersecting) continue;
      io.unobserve(el); bekleyen.delete(el);
      kuyruk.push(el);
      if (!zaman) zaman = setTimeout(oynat, 80);
    }
  }, { rootMargin: '0px 0px -8% 0px' });

  // Kartlar satırları üzerinden izlenir: yatay kayan şeritte ekran dışındaki kartlar da satır görününce
  // birlikte gelir (v1'deki gibi; tek tek izlense yana kaydırdıkça sonradan solarlardı).
  const satirKart = new Map();
  const satirIo = new IntersectionObserver((girdiler) => {
    for (const e of girdiler) {
      const satir = e.target, kartlar = satirKart.get(satir) || [];
      if (!satir.dataset.nxIlk) {
        satir.dataset.nxIlk = '1';
        if (e.isIntersecting) { satirIo.unobserve(satir); satirKart.delete(satir); continue; }
        kartlar.forEach((k) => gizle(k, 26));
        continue;
      }
      if (!e.isIntersecting) continue;
      satirIo.unobserve(satir); satirKart.delete(satir);
      kartlar.forEach((k, i) => goster(k, 26, { duration: 0.6, ease: 'power3.out', delay: Math.min(i, 5) * 0.06 }));
    }
  }, { rootMargin: '0px 0px -8% 0px' });

  const izle = (kok) => (kok || document).querySelectorAll(`${KART},${OGE},${BASLIK}`).forEach((el) => {
    if (el.dataset.nxIzle || el.closest('[data-panel], template')) return;
    // iç içe kart (ör. .resource-list__slide > .resource-list__item): yalnız dıştaki izlenir, içteki kendi kabını izleyip gizli kalmasın
    if (el.matches(KART) && el.parentElement && el.parentElement.closest(KART)) return;
    el.dataset.nxIzle = '1';
    if (el.matches(KART) && el.parentElement) {
      const s = el.parentElement;
      if (!satirKart.has(s)) { satirKart.set(s, []); satirIo.observe(s); }
      satirKart.get(s).push(el);
      return;
    }
    io.observe(el);
  });
  izle();
  window.nidaHareketIzle = izle; // sonradan eklenen içerik için

  // Koli bandı büyük rakamları: hafif ölçek vurgusu (v1 ile aynı)
  const vurgu = new IntersectionObserver((gg) => gg.forEach((e) => {
    if (!e.isIntersecting) return; vurgu.unobserve(e.target);
    g.fromTo(e.target, { scale: 0.86 }, { scale: 1, duration: 0.7, ease: 'back.out(2)', clearProps: 'transform' });
  }), { rootMargin: '0px 0px -12% 0px' });
  document.querySelectorAll('.nkv__big').forEach((el) => vurgu.observe(el));

  // Sepete ekleme: sepet ikonu zıplar
  document.addEventListener('cart:update', () => {
    const ikon = document.querySelector('.header-actions__cart-icon');
    if (ikon) g.fromTo(ikon, { scale: 1 }, { scale: 1.22, duration: 0.18, yoyo: true, repeat: 1, ease: 'power2.out', clearProps: 'transform' });
  });

  // Kartta hızlı ekle kutusu açılınca bedenler sırayla gelir
  document.addEventListener('pointerover', (e) => {
    const kap = e.target.closest?.('.card-gallery, .nsc-kart__gorsel');
    if (!kap || kap.dataset.nxAcildi) return;
    const b = kap.querySelectorAll('.nbs__b');
    if (!b.length) return;
    kap.dataset.nxAcildi = '1';
    g.from(b, { autoAlpha: 0, y: 6, duration: 0.28, stagger: 0.012, ease: 'power2.out', clearProps: temizle });
  }, { passive: true });

  // Güvenlik ağı (yoklamasız): animasyon motoru 1,5 sn'de kare üretmediyse ya da sekme gizlenirse her şeyi aç
  const hepsiniAc = () => {
    bekleyen.forEach((el) => { el.classList.remove('nx-gizli'); g.set(el, { clearProps: temizle }); io.unobserve(el); }); bekleyen.clear();
    satirKart.forEach((kartlar, s) => { kartlar.forEach((k) => { k.classList.remove('nx-gizli'); g.set(k, { clearProps: temizle }); }); satirIo.unobserve(s); }); satirKart.clear();
    document.querySelectorAll('.nx-gizli').forEach((el) => el.classList.remove('nx-gizli'));
  };
  const kare0 = g.ticker.frame;
  setTimeout(() => { if (g.ticker.frame === kare0) hepsiniAc(); }, 1500);
  addEventListener('visibilitychange', () => { if (document.hidden) hepsiniAc(); });
 };
 // (2026-09-28) masaüstünde de ilk etkileşimde (fare hareketi dahil) kurulur.
 let oldu = false;
 const ac = () => { if (oldu) return; oldu = true; (window.nidaGsapYukle ? window.nidaGsapYukle() : Promise.resolve()).then(kur); };
 ['pointerdown', 'pointermove', 'touchstart', 'wheel', 'keydown'].forEach(e => addEventListener(e, ac, { once: true, passive: true, capture: true }));
 addEventListener('scroll', ac, { once: true, passive: true });
})();
